<template>
  <div
    id="carouselExampleIndicators"
    class="carousel slide"
    data-bs-ride="carousel"
  >
    <div class="carousel-indicators">
      <button
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide-to="0"
        class="active"
        aria-current="true"
        aria-label="Slide 1"
      ></button>
      <button
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide-to="1"
        aria-label="Slide 2"
      ></button>
      <button
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide-to="2"
        aria-label="Slide 3"
      ></button>
    </div>
    <div class="carousel-inner">
      <div class="carousel-item active">
        <img
          class="d-block w-100"
          src="../assets/doug_pass.webp"
          alt="Ridge Soaring"
          fetchpriority="high"
        >
        <div class="carousel-caption d-none d-md-block">
          <h5 class="carousel-text" v-if="false"
            style="font-size: 1.75rem;">Paragliding Colorado's Western Slope</h5>
        </div>
      </div>
      <div class="carousel-item">
        <img src="../assets/crusin.webp" class="d-block w-100" alt="one" />
      </div>
      <div class="carousel-item">
        <img src="../assets/stove_pipe.webp" class="d-block w-100" alt="one" />
      </div>
    </div>
    <button
      class="carousel-control-prev"
      type="button"
      data-bs-target="#carouselExampleIndicators"
      data-bs-slide="prev"
    >
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button
      class="carousel-control-next"
      type="button"
      data-bs-target="#carouselExampleIndicators"
      data-bs-slide="next"
    >
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'CarouselComponent',
  props: {},
};
</script>

<style scoped>
/* Container holding the image and the text */
.image-container {
  position: relative;
  text-align: center;
  color: white;
}

/* Bottom left text */
.bottom-left {
  position: absolute;
  bottom: 8px;
  left: 16px;
}

/* Top left text */
.top-left {
  position: absolute;
  top: 8px;
  left: 16px;
}

/* Top right text */
.top-right {
  position: absolute;
  top: 8px;
  right: 16px;
}

/* Bottom right text */
.bottom-right {
  position: absolute;
  bottom: 8px;
  right: 16px;
}

/* Centered text */
.centered {
  position: absolute;
  top: 38%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 40px;
  font-weight: bold;
  /* text-shadow: 2px 2px black; */
  text-shadow: -1px 0 gray, 0 1px gray, 1px 0 gray, 0 -1px gray;
}
.carousel-text {
  text-shadow: -1px 0 gray, 0 1px gray, 1px 0 gray, 0 -1px gray;
}
</style>
